import React from 'react';

export default (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.5C4.4 14.5 1.5 11.6 1.5 8C1.5 4.4 4.4 1.5 8 1.5C11.6 1.5 14.5 4.4 14.5 8C14.5 11.6 11.6 14.5 8 14.5Z" fill="#2A2B2B" />
    <path d="M11.5 7.4H8.9V4.7C8.9 4.3 8.5 4 8.1 4C7.7 4 7.4 4.3 7.4 4.7V7.3H4.7C4.3 7.4 4 7.7 4 8.1C4 8.5 4.3 8.8 4.7 8.8H7.3V11.4C7.3 11.8 7.6 12.1 8 12.1C8.2 12.1 8.4 12 8.5 11.9C8.6 11.8 8.7 11.6 8.7 11.4V8.9H11.3C11.5 8.9 11.7 8.8 11.8 8.7C11.9 8.6 12 8.4 12 8.2C12.2 7.7 11.9 7.4 11.5 7.4Z" fill="#2A2B2B" />
  </svg>
);
